<template>
  <div class="modal">
    <div class="modal__box__accepted_funds">
      <div class="modal__box__close">
        <div class="modal__box__close__icon" @click="close()">
          <icon-big-close />
        </div>
      </div>
      <div class="modal__box__title">
        <slot name="title" />
      </div>
      <div class="modal__box__content">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
import { clickOutside } from "@/directives/";
export default {
  directives: {
    "click-outside": clickOutside,
  },
  methods: {
    close: function () {
      this.$emit("close");
    },
  },
};
</script>